import React from "react";
import styled from "styled-components";

const StyledBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 500;
`;

const StyledProgressBarFrame = styled.div`
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    width: 552px;
    height: 146px;
    background: white;
    padding: 44px 40px;
    border-radius: 5px;
    box-shadow: 0px 11px 27px #00000033;
`;

const StyledLeftText = styled.span`
    position: relative;
    // top: 10px;
    float: left;
    font-size: 20px;
    font-family: NanumSquareB;
`;

const StyledRightText = styled.span`
    position: relative;
    // top: 10px;
    float: right;
    font-size: 20px;
    font-family: NanumSquareB;
`;


const StyledProgressBar = styled.div`
    border-radius: 50px;
    top: 11px;
    height: 16px;
    display: inline-block;
    position: relative;
    width: 100%;
    right: 0;
    background: #E8E8E8;
    .playbar {
        border-radius: 50px;
        position: relative;
        background: #585AD1;
        width: ${(props) => (props as any)['data-percentage']}%;
        
        height:100%;
        transition:all 1s linear;
    }
`;

interface IProgressBar {
    className?: string,
    percentage: number,
    leftText?: string,
    rightText?: string
}

const ProgressBar: React.FC<IProgressBar> = (({
                                                  className,
                                                  percentage,
                                                  leftText,
                                                  rightText
                                              }) => {
    return (
        <StyledBackground>
            <StyledProgressBarFrame>
                <StyledLeftText>{leftText}</StyledLeftText> <StyledRightText>{rightText}</StyledRightText>
                <StyledProgressBar className={className} data-percentage={percentage}>
                    <div className='playbar'></div>
                </StyledProgressBar>
            </StyledProgressBarFrame>
        </StyledBackground>
    )
});

export default ProgressBar;